import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";
import { getProgressColorStyle } from "../controls/ProgressbarView";

export class ProgressbarTransform extends EldmlTransform {
  apply() {
    this.selector.find("progressbar").each(function (_: any, element: Element) {
      const progressBar = $(element)
      const progress = $('<div class="eldml-progress"></div>');

      let percent = parseInt(progressBar.attr("percent") ?? "");
      percent = isNaN(percent) ? 0 : percent;

      let colorStyle = getProgressColorStyle(percent);

      const animateStyle = progressBar.attr("animate") === "true" ? "animate" : "";

      if (progressBar.attr("type") === "radial") {
        const parsedSize = parseInt(progressBar.attr("size") ?? "");
        let size = isNaN(parsedSize) ? 5 : parsedSize;
        size = size > 10 ? 10 : size < 1 ? 1 : size;

        progress.addClass("progress-radial");

        if (progressBar.attr("hide-value") === "true") {
          progress.addClass("hidden-value");
        }
        progress.addClass("size-" + size);

        const label = progressBar.attr("label");
        const content = $('<div class="progress-content"></div>');
        const svg = $(
          '<svg class="progress-svg" width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"></svg>',
        );
        svg.append($('<circle class="track"></circle>'));
        svg.append($('<circle class="bar"></circle>'));
        if (progressBar.attr("hide-value") !== "true") {
          svg.append(
            $(
              `<text class="progress-value" x="50%" y="${label ? "42" : "50"}%"></text>`,
            ).text(percent + "%"),
          );
        }
        if (label) {
          const labelDiv = $(
            '<div xmlns="http://www.w3.org/1999/xhtml"></div>',
          ).text(label);
          labelDiv.attr("title", label);
          const showValue = progressBar.attr("hidden-value") !== "true";
          const foreignObject = $(
            `<foreignObject class="progress-label-html" width="100%" height="2em" x="0" y="${showValue ? "55" : "50"}%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility" ></foreignObject>`,
          );
          foreignObject.append(labelDiv);
          svg.append(foreignObject);
        }
        content.append(svg);
        progress.append(content);
        progress
          .find(".progress-content")
          .html(progress.find(".progress-content").html());
        const offset = 45 * Math.PI * 2 * (1 - percent / 100);
        progressBar.replaceWith(progress);

        setTimeout(function () {
          progress.find(".bar").css({ strokeDashoffset: offset + "%" });
          progress.addClass(animateStyle).find("circle").addClass(colorStyle);
        }, 0);
      } else {
        progress.addClass("progress type-bar");
        const bar = $('<div class="progress-bar" role="progressbar" ></div>');
        const progressValue = percent + "%";
        bar.html("&nbsp;" + progressValue);
        progress.append(bar);
        progressBar.replaceWith(progress);
        setTimeout(function () {
          progress.find(".progress-bar").css({ width: progressValue });
          progress.addClass(animateStyle).addClass(colorStyle);
        }, 0);
      }
    });
  }
}
